import * as watcherSagas from './watcherSagas'

export {
  locationDetailReducer,
  LocationPopularAreasReducer,
  LocationRecommendedSpacesReducer,
  LocationCoinLockersReducer,
  LocationStationsReducer,
  LocationFacilitiesReducer,
  locationOldCoinLockersReducer,
} from './reducers'
export type {
  LocationDetailState,
  LocationPopularAreasState,
  LocationRecommendedSpacesState,
  LocationCoinLockersState,
  LocationStationsState,
  LocationFacilitiesState,
  LocationOldCoinLockersState,
} from './reducers'

export const locationWatcherSagas = Object.values(watcherSagas)
